"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AlertProvider = exports.useAlerta = void 0;
var react_1 = __importStar(require("react"));
var react_dom_1 = __importDefault(require("react-dom"));
var uuid_1 = require("uuid");
var AlertaPortal_1 = require("../componentes/Alerta/AlertaPortal/AlertaPortal");
var AlertContext = (0, react_1.createContext)(undefined);
var useAlerta = function () {
    var context = (0, react_1.useContext)(AlertContext);
    if (!context) {
        throw new Error("useAlert must be used within an AlertProvider");
    }
    return context;
};
exports.useAlerta = useAlerta;
var AlertProvider = function (_a) {
    var children = _a.children;
    var _b = (0, react_1.useState)([]), alerts = _b[0], setAlerts = _b[1];
    var alertsRef = (0, react_1.useRef)(alerts);
    var removeAlert = (0, react_1.useCallback)(function (id) {
        alertsRef.current = alertsRef.current.filter(function (alert) { return alert.id !== id; });
        setAlerts(__spreadArray([], alertsRef.current, true));
    }, []);
    var verificarAlertaDuplicado = function (alerta) {
        return alertsRef.current.some(function (alert) {
            return alert.descricao === alerta.descricao &&
                alert.titulo === alerta.titulo;
        });
    };
    var showAlert = (0, react_1.useCallback)(function (alert) {
        if (verificarAlertaDuplicado(alert))
            return;
        var id = (0, uuid_1.v4)();
        var newAlert = __assign(__assign({}, alert), { id: id, onFechar: function () { return removeAlert(id); } });
        alertsRef.current = __spreadArray(__spreadArray([], alertsRef.current, true), [newAlert], false);
        setAlerts(__spreadArray([], alertsRef.current, true));
    }, [removeAlert]);
    var hideAlert = function () {
        setAlerts([]);
    };
    var createAlertFunction = function (tipo, tituloPadrao) {
        return function (mensagem, opcoes) {
            var _a, _b, _c;
            var titulo = (_a = opcoes === null || opcoes === void 0 ? void 0 : opcoes.titulo) !== null && _a !== void 0 ? _a : "";
            var estilo = (_b = opcoes === null || opcoes === void 0 ? void 0 : opcoes.estilo) !== null && _b !== void 0 ? _b : "filled";
            var duracao = (_c = opcoes === null || opcoes === void 0 ? void 0 : opcoes.tempo) !== null && _c !== void 0 ? _c : 9000;
            //let verMais = opcoes?.verMais ?? false;
            var id = "alert-".concat(estilo, "-").concat((0, uuid_1.v4)());
            showAlert({
                id: id,
                descricao: mensagem,
                tipo: tipo,
                estilo: estilo,
                titulo: titulo !== null && titulo !== void 0 ? titulo : tituloPadrao,
                validadeInicial: new Date().getTime(),
                validadeFinal: new Date().getTime() + duracao,
                onVerMais: function () { },
                limiteCaracteresExibicaoDescricao: 600,
                onFechar: function () { return removeAlert(id); },
                telemetria: opcoes === null || opcoes === void 0 ? void 0 : opcoes.telemetria,
            });
        };
    };
    var error = createAlertFunction("error", "Erro");
    var warning = createAlertFunction("warning", "Aviso");
    var success = createAlertFunction("success", "Sucesso");
    var info = createAlertFunction("info", "Informação");
    return (react_1.default.createElement(AlertContext.Provider, { value: {
            mostrarAlerta: showAlert,
            esconderAlerta: hideAlert,
            error: error,
            warning: warning,
            success: success,
            info: info,
        } },
        children,
        react_dom_1.default.createPortal(react_1.default.createElement(AlertaPortal_1.AlertaPortal, { alerts: alerts, removerAlerta: removeAlert }), document.body)));
};
exports.AlertProvider = AlertProvider;
